export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "本期导读", href: "#index" },
  { label: "获取方式", href: "#ways" },
  { label: "渠道入口", href: "#channels" },
  { label: "使用攻略", href: "#guide" },
  { label: "吃瓜合集", href: "#collections" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "12", label: "条入口索引" },
  { value: "36", label: "篇攻略要点" },
  { value: "0", label: "门槛上手" },
];

export const indexBoard = [
  {
    no: "01",
    title: "黑料免费到底能从哪拿到",
    summary: "把散落在各处的公开入口按可用度重新排了一遍，先看这一条就不会乱跑。",
    tag: "入口总览",
  },
  {
    no: "02",
    title: "三种获取方式，新手先挑最省事的",
    summary: "订阅式、聚合式、手动检索式，各自的耐心成本和信息新鲜度差别挺大。",
    tag: "获取方式",
  },
  {
    no: "03",
    title: "渠道入口怎么看才不算白看",
    summary: "同一个入口，会看的人五分钟抓到重点，不会看的人刷半小时还在原地。",
    tag: "使用攻略",
  },
  {
    no: "04",
    title: "热门吃瓜合集，按时间线整理",
    summary: "把零散的信息串成有先后顺序的合集，看事件比看碎片省力得多。",
    tag: "合集索引",
  },
  {
    no: "05",
    title: "入口打不开、内容没更新怎么办",
    summary: "常见状况的处理顺序写清楚了，先排查再换入口，别一上来就乱点。",
    tag: "问题排查",
  },
];

export const accessWays = [
  {
    id: "subscribe",
    icon: "ri-notification-3-line",
    title: "订阅式获取",
    summary: "一次设置，之后有更新自动汇过来，适合只想偶尔看看、不想天天找入口的人。",
    points: ["更新到得比较及时", "基本不用自己搜", "需要先完成一次订阅动作"],
  },
  {
    id: "aggregate",
    icon: "ri-layout-grid-line",
    title: "聚合式获取",
    summary: "多个来源收在同一页里，按热度或时间摊开，适合喜欢横向对比、自己挑着看的人。",
    points: ["一页看多个来源", "可按时间或热度排", "信息量偏大，需要挑重点"],
  },
  {
    id: "manual",
    icon: "ri-search-eye-line",
    title: "手动检索式",
    summary: "用关键词自己找，灵活度最高，适合已经知道自己想看什么、目标很明确的人。",
    points: ["想看什么就搜什么", "灵活不受推荐限制", "需要一点关键词技巧"],
  },
];

export const channelEntries = [
  {
    name: "公开资讯聚合页",
    desc: "以时间线整理公开信息，适合快速浏览最近都在讨论什么。",
    tag: "时间线",
    heat: "稳定",
    icon: "ri-time-line",
  },
  {
    name: "话题合集索引",
    desc: "把同一件事的相关内容归到一个合集里，从头到尾顺着看即可。",
    tag: "合集",
    heat: "推荐",
    icon: "ri-bookmark-3-line",
  },
  {
    name: "热榜速览入口",
    desc: "按讨论量排的速览清单，用来判断哪件事值得花时间深入。",
    tag: "热榜",
    heat: "高频",
    icon: "ri-fire-line",
  },
  {
    name: "关键词检索入口",
    desc: "目标明确时直接搜，配合攻略里的关键词技巧命中率更高。",
    tag: "检索",
    heat: "灵活",
    icon: "ri-search-line",
  },
  {
    name: "更新订阅入口",
    desc: "设置一次之后，有新内容会主动汇过来，省去反复找入口的步骤。",
    tag: "订阅",
    heat: "省事",
    icon: "ri-rss-line",
  },
  {
    name: "新手指引入口",
    desc: "什么都不熟就先从这里进，整套流程和术语都做了说明。",
    tag: "入门",
    heat: "友好",
    icon: "ri-compass-3-line",
  },
];

export const guideSteps = [
  {
    step: "STEP 1",
    title: "先确定你想看的是哪一类",
    desc: "明确目标比盲目刷更有效。是想跟热点，还是想回头补某件事的全过程，决定了你该走哪个入口。",
  },
  {
    step: "STEP 2",
    title: "从入口索引里挑一个进",
    desc: "本期导读里按可用度排过序，直接按顺序试，比随手点一个成功率更高，也不容易在无效入口上耗时间。",
  },
  {
    step: "STEP 3",
    title: "用关键词把范围缩小",
    desc: "把模糊的想法换成具体的人名、事件名或时间点，检索结果会集中很多，翻找量能明显降下来。",
  },
  {
    step: "STEP 4",
    title: "按时间线把碎片串起来",
    desc: "单个片段容易看得云里雾里，找到合集或时间线从上往下读一遍，前后因果就顺了。",
  },
  {
    step: "STEP 5",
    title: "设置一次订阅，之后省事",
    desc: "常用入口配置好更新提醒，后面就不用每次都从头找，这也是很多人用顺手之后最省事的一步。",
  },
];

export const collections = [
  {
    title: "近期热度合集",
    meta: "更新于本周 · 18 条内容",
    desc: "把最近讨论最多的几件事按热度排好，用来快速判断这几天大家都在聊什么。",
    image: "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20vintage%20newspaper%20clippings%20and%20a%20crimson%20wax%20seal%20on%20a%20textured%20cream%20paper%20surface%2C%20warm%20amber%20side%20lighting%2C%20soft%20shadows%2C%20minimal%20props%2C%20no%20text%2C%20warm%20neutral%20palette%20with%20crimson%20accents%2C%20high%20detail%20still%20life%20photography&width=800&height=600&seq=hl-collection-01&orientation=landscape",
  },
  {
    title: "事件时间线合集",
    meta: "更新于上周 · 24 条内容",
    desc: "同一件事从起因到后续按顺序排开，习惯从头看的人会舒服很多。",
    image: "https://readdy.ai/api/search-image?query=Stacked%20aged%20archive%20folders%20and%20tan%20card%20tags%20with%20twine%20on%20a%20matte%20beige%20desk%20surface%2C%20warm%20directional%20daylight%2C%20restrained%20lines%2C%20soft%20shadow%2C%20no%20text%2C%20warm%20neutral%20and%20rust%20palette%2C%20editorial%20magazine%20still%20life%20photography%20high%20detail&width=800&height=600&seq=hl-collection-02&orientation=landscape",
  },
  {
    title: "冷门但值得看",
    meta: "更新于本月 · 12 条内容",
    desc: "热度不高但信息扎实的那一类，适合已经刷完热榜、想再往深看一点的人。",
    image: "https://readdy.ai/api/search-image?query=Open%20vintage%20book%20with%20amber%20dried%20flowers%20and%20a%20brass%20magnifier%20resting%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20light%2C%20quiet%20minimal%20composition%2C%20no%20text%2C%20warm%20neutral%20palette%20with%20muted%20green%20accents%2C%20fine%20art%20still%20life%20photography&width=800&height=600&seq=hl-collection-03&orientation=landscape",
  },
  {
    title: "新手入门合集",
    meta: "长期更新 · 9 条内容",
    desc: "从零开始的一整套流程，术语、入口、判断方法都配了说明，第一次来先看这个。",
    image: "https://readdy.ai/api/search-image?query=Neat%20desk%20corner%20with%20a%20closed%20kraft%20notebook%2C%20a%20crimson%20ribbon%20bookmark%20and%20a%20small%20amber%20ceramic%20cup%20on%20a%20textured%20off%20white%20paper%20background%2C%20gentle%20daylight%2C%20clean%20restrained%20arrangement%2C%20no%20text%2C%20warm%20neutral%20palette%2C%20editorial%20product%20still%20life&width=800&height=600&seq=hl-collection-04&orientation=landscape",
  },
];

export const faqs = [
  {
    q: "黑料免费的获取方式是收费的吗？",
    a: "页面里整理的获取方式与渠道入口都是公开可用的途径，不涉及付费环节。真正需要花的是时间，所以攻略的重点放在怎么少走弯路上。",
  },
  {
    q: "为什么我照着入口进，还是找不到想看的内容？",
    a: "多数情况是关键词太宽。把范围缩到具体的人名、事件名或时间点，结果会集中很多；如果仍然没有，换下一个入口再试，别在同一个入口反复刷新。",
  },
  {
    q: "渠道入口会不会经常变？",
    a: "公开入口的可用度会波动，所以本期导读里是按可用度排序的。平时建议一次配置好几个常用入口，某个不好用的时候直接切另一个。",
  },
  {
    q: "完全没接触过，应该从哪一步开始？",
    a: "先看使用攻略的五个步骤，重点看第一步和第二步：先确定自己想看哪一类，再从入口索引里按顺序挑。这两步做对了，后面基本不用摸索。",
  },
  {
    q: "怎么保证不错过更新？",
    a: "在更新订阅入口设置一次提醒就可以了，之后有新内容会汇过来，不需要每天都主动去翻找入口。",
  },
];

export const footerColumns = [
  {
    title: "内容",
    links: ["本期导读", "获取方式", "渠道入口", "使用攻略"],
  },
  {
    title: "索引",
    links: ["吃瓜合集", "热度速览", "时间线整理", "新手入门"],
  },
  {
    title: "帮助",
    links: ["常见问题", "入口排查", "关键词技巧", "更新订阅"],
  },
];